import format from "date-fns/format";

import type { Config } from "@/components/Ui/LineChart";
import { formatCurrencyCompact, roundNumber } from "@/utils";

export const config: Config = [
  {
    label: "DATE",
    dataKey: "timestamp",
    stroke: "hsl(var(--twc-neutral-600))",
    xAxis: {
      // @ts-ignore
      tickFormatter: value => format(value, "MMM dd").toUpperCase(),
      position: "bottom",
    },
  },
  {
    label: "TVL",
    dataKey: "tvl",
    stroke: "hsl(var(--twc-neutral-600))",
    // @ts-ignore
    yAxis: {
      tickFormatter: value => (value != null ? formatCurrencyCompact(value, 2, 0) : ""),
      formatter: value => (value != null ? roundNumber(value, { maxFractionDigits: 2 }) : undefined),
      position: "left",
      width: 60,
      tickCount: 4,
      startFromZero: true,
    },
    line: {
      dotR: 2,
    },
  },
  /* {
    label: "DEPOSITORS (,000s)",
    dataKey: "depositors",
    stroke: "#F26057",
    yAxis: {
      tickFormatter: (value: number) => formatCurrencyCompact(value, 2, 0, "decimal"),
      formatter: (value: number) => roundNumber(value, { maxFractionDigits: 2 }),
      position: "right",
      width: 70,
      tickCount: 4,
      startFromZero: true,
    },
    line: {
      dotR: 3,
      strokeDasharray: "1 1",
    },
   }, */
  /* {
    label: "VAULTS",
    dataKey: "vaults",
    stroke: "#C69B41",
    yAxis: {
      tickFormatter: (value: number) => formatCurrencyCompact(value, 2, 0, "decimal"),
      formatter: (value: number) => roundNumber(value, { maxFractionDigits: 2 }),
      position: "right",
      width: 70,
      tickCount: 4,
      startFromZero: true,
    },
    line: {
      dotR: 3,
      strokeDasharray: "4 4",
    },
   }, */
];
